import client from './client';

export const paymentAPI = {
  // درگاه‌های پرداخت مجاز برای سایت جاری (بدون auth) — برای نمایش انتخاب‌گر
  // «تومانی یا کریپتو» فقط وقتی بیش از یک درگاه فعال است.
  getAvailableGateways: () => client.get('/payment/available-gateways'),

  getGalleonPacks: () => client.get('/payment/galleon-packs'),
  requestGalleonPackPayment: (key, gateway) => client.post('/payment/request-galleon-pack', { key, gateway }),
  requestTrainTicketPayment: (gateway) => client.post('/payment/request-train-ticket', { gateway }),
  requestFullPackagePayment: (gateway) => client.post('/payment/request-full-package', { gateway }),

  // خرید «بسته کامل ورود» برای شخص دیگری (هدیه) — حساب خودِ خریدار دست‌نخورده
  // می‌ماند، فقط یک دعوت‌نامه‌ی قابل‌انتقال برای گیرنده ساخته می‌شود.
  requestGiftPackagePayment: ({ recipientFirstName, recipientLastName, recipientPhone, addressLine1, addressLine2, addressLine3, gateway }) =>
    client.post('/payment/request-gift-package', {
      recipientFirstName, recipientLastName, recipientPhone, addressLine1, addressLine2, addressLine3, gateway
    }),

  getTransaction: (id) => client.get(`/payment/transaction/${id}`),
  getTransactions: () => client.get('/payment/transactions'),
};
